import { Directive, Input, SimpleChanges } from '@angular/core';

import { TooltipDirective } from './tooltip.directive';
import { IRxntTooltipOptions } from './rxnt-tooltip-options.model';

@Directive({
  selector: '[tooltipAlias],[tooltipOptionsAlias]',
  standalone: false,
})
export class TooltipAliasDirective extends TooltipDirective {
  @Input() tooltipAlias: string = '';
  @Input() tooltipOptionsAlias: IRxntTooltipOptions = {};

  override ngOnChanges(changes: SimpleChanges) {
    this.tooltip = this.tooltipAlias;
    this.tooltipOptions = this.tooltipOptionsAlias;

    super.ngOnChanges(changes);
  }
}
